// Simple cache service for storing and retrieving data
class CacheService {
  constructor() {
    this.cache = new Map();
    this.expiries = new Map();
  }

  /**
   * Set a value in cache with optional expiry time
   * @param {string} key - Cache key
   * @param {*} value - Value to cache
   * @param {number} expiryMs - Expiry time in milliseconds (optional)
   */
  set(key, value, expiryMs = null) {
    this.cache.set(key, value);
    
    if (expiryMs) {
      // Clear any existing timeout
      if (this.expiries.has(key)) {
        clearTimeout(this.expiries.get(key));
      }
      
      // Set new expiry
      const timeoutId = setTimeout(() => {
        this.cache.delete(key);
        this.expiries.delete(key);
      }, expiryMs);
      
      this.expiries.set(key, timeoutId);
    }
  }

  /**
   * Get a value from cache
   * @param {string} key - Cache key
   * @returns {*} Cached value or undefined
   */
  get(key) {
    return this.cache.get(key);
  }

  /**
   * Check if a key exists in cache
   * @param {string} key - Cache key
   * @returns {boolean}
   */
  has(key) {
    return this.cache.has(key);
  }

  /**
   * Remove a value from cache
   * @param {string} key - Cache key
   */
  remove(key) {
    if (this.expiries.has(key)) {
      clearTimeout(this.expiries.get(key));
      this.expiries.delete(key);
    }
    this.cache.delete(key);
  }

  /**
   * Clear all cache
   */
  clear() {
    this.expiries.forEach(timeoutId => clearTimeout(timeoutId));
    this.cache.clear();
    this.expiries.clear();
  }

  /**
   * Get all cache keys
   * @returns {string[]}
   */
  keys() {
    return Array.from(this.cache.keys());
  }
}

// Export singleton instance
export const cacheService = new CacheService();
